import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../../app/context'
import { Report } from '../../domain/Report'
import { RangeSelectorInterface } from '../../history/RangeSelectorInterface'
import { ApplicationState } from '../../redux/ApplicationState'
import Chart from './history_range.d3'
import { newResizeObserver } from '../../helper/resizeObserver'
import { convertDate } from '../../helper/convertDate'

type rangeSelectedFunction = (event: JQueryEventObject, dataSet: any, nextDataSet: any) => void

interface OwnProps {
    history: Report<any>
    renderScrollbar: boolean
    rangeSelected: rangeSelectedFunction | null
    daysOnScale: number
    selector: RangeSelectorInterface
    dataFixedTimezone?: string
}

interface StateProps {
    tidewaysContext: TidewaysContext
    parameters: { [key: string]: string }
}

type Props = OwnProps & StateProps

class TimeRange extends React.Component<Props> {
    public static defaultProps = {
        renderScrollbar: true,
        rangeSelected: null,
    }

    private historyRangeSvg
    private chart
    public resizeObserver

    public componentDidMount() {
        if (!this.chart) {
            this.createChart()
        }

        if (this.props.renderScrollbar) {
            this.forceUpdate()
        } else {
            setTimeout(() => {
                this.forceUpdate()
            }, 0)
        }
    }

    public componentDidUpdate(prevProps) {
        if (!this.chart) {
            this.createChart()
        }

        if (!this.resizeObserver && this.chart) {
            this.setResizeObserver()
        }

        this.updateChart()
    }

    public createChart() {
        this.chart = new Chart()
        const chartElement = this.getChartElement()
        const parentNode = jQuery(chartElement).parent()

        parentNode.height(105)
        this.chart.create(chartElement, parentNode.width(), 100, {
            renderScrollbar: this.props.renderScrollbar,
            xAxisTicks: this.props.renderScrollbar ? 20 : 5,
            daysOnScale: this.props.daysOnScale,
        })

        jQuery(this.getChartElement()).on(
            'rangeSelected',
            this.props.rangeSelected ||
                ((event, dataSet, nextDataSet) => {
                    event.preventDefault()
                    event.stopPropagation()

                    this.props.selector.setStartEnd(dataSet.date, nextDataSet.date)
                }),
        )
    }

    public componentWillUnmount() {
        this.destroyChart()
        this.resizeObserver?.disconnect()
    }

    public getChartElement = () => this.historyRangeSvg

    private rebuildChart = () => {
        this.destroyChart()
        this.createChart()
        if (this.chart) this.updateChart()
    }

    private destroyChart = () => {
        this.chart?.destroy() // remove svg-elements from dom
        this.chart = null // remove reference to the object
    }

    public updateChart = () => {
        const range = this.props.selector.getRange()

        this.chart.update(
            [
                {
                    name: 'requests',
                    data: Object.entries(this.props.history.requests).map(([key, value]) => ({
                        axis: 'requests',
                        date: convertDate(key, this.props.dataFixedTimezone),
                        value,
                        responseTime: this.props.history.percentileResponseTimes[key] || null,
                        requests: this.props.history.requests[key] || null,
                        errors: this.props.history.errors[key] || null,
                    })),
                },
                {
                    name: 'response',
                    data: Object.entries(this.props.history.percentileResponseTimes).map(([key, value]) => ({
                        axis: 'response',
                        date: convertDate(key, this.props.dataFixedTimezone),
                        value,
                    })),
                },
                {
                    name: 'errors',
                    data: Object.entries(this.props.history.errors).map(([key, value]) => ({
                        axis: 'requests',
                        date: convertDate(key, this.props.dataFixedTimezone),
                        value,
                    })),
                },
            ],
            [
                {
                    start: range.getStartDate().toDate(),
                    end: range.getEndDate().toDate(),
                },
            ],
        )
    }

    private setResizeObserver = () => {
        const chartElement = this.getChartElement()
        const parentNode = jQuery(chartElement as string).parent()
        this.resizeObserver = newResizeObserver(this.rebuildChart)
        this.resizeObserver.observe(parentNode[0])
    }

    public render() {
        return (
            <div className="row" style={{ marginBottom: '-6px' }}>
                <div className="col-lg-12 text-center">
                    <div className="chart history">
                        <svg
                            ref={element => {
                                this.historyRangeSvg = element
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    return {
        ...props,
        tidewaysContext: globalState.tidewaysContext,
        parameters: globalState.tidewaysContext.route.parameters,
    }
})(TimeRange)
